import {SubscriptionSource, SubscriptionSourceUtils} from 'common';
import {SubscriptionPaymentsHistoryDto} from '../dtos/subscriptionPaymentsHistory.dto';

export class RecentAccountPaymentsReportDataViewModel {
    code: string;
    position: number;
    fullName: string;
    email: string;
    subscription: string;
    subscriptionPeriodUnit: string;
    paymentDate: number;
    subscriptionSource: string;
    amount: number;
    discount: number;
    renewalStatus: boolean;
    active: boolean;

    public from(reports: SubscriptionPaymentsHistoryDto[]): RecentAccountPaymentsReportDataViewModel[] {
        const data = [];
        let count = 0;
        reports.forEach((report) => {
            report.subscriptions.forEach((subscription) => {
                subscription.payments.filter(payment => !payment.trial).forEach((payment) => {
                    count++;
                    const convertedData = new RecentAccountPaymentsReportDataViewModel();
                    convertedData.code = report.code;
                    convertedData.position = count;
                    convertedData.fullName = report.fullName;
                    convertedData.email = report.email;
                    convertedData.subscription = subscription.subscription;
                    convertedData.subscriptionPeriodUnit = subscription.subscriptionPeriodUnit;
                    convertedData.subscriptionSource = subscription.subscriptionSource ? SubscriptionSourceUtils.title(subscription.subscriptionSource as SubscriptionSource) : undefined;
                    convertedData.amount = payment.amount;
                    convertedData.paymentDate = payment.paymentDate;
                    convertedData.discount = payment.discount;
                    convertedData.renewalStatus = subscription.renewalStatus;
                    convertedData.active = subscription.active;
                    data.push(convertedData);
                });
            });
        });

        return data;
    }
}
